/** local = bundled JSON under pages/docs/config/legal; s3 = contentUrl from GET /api/legal/current */
export const LEGAL_DOCS_SOURCE =
  process.env.REACT_APP_LEGAL_DOCS_SOURCE ?? process.env.REACT_APP_DOCS_SOURCE ?? "local";

export const isLegalLocalMode = () => LEGAL_DOCS_SOURCE !== "s3";
